import type {
  CottageMediaItemsType,
  CottagePhotoItemType,
  CottageVideoItemType,
} from '~~/modules/views/cottage/entities/Cottage'

export const useCottageMedia = () => {
  const getVideoItems = (
    item: CottageMediaItemsType,
  ): CottageVideoItemType[] => {
    const returnSlides: CottageVideoItemType[] = []

    item.forEach(element => {
      if (element.type === 'VIDEO') {
        const videoItem: CottageVideoItemType = {
          url: element.url,
          type: element.type,
          alt: element.alt,
          width: null,
          height: null,
        }

        returnSlides.push(videoItem)
      }
    })

    return returnSlides
  }

  const getPhotoItems = (
    item: CottageMediaItemsType,
  ): CottagePhotoItemType[] => {
    const returnSlides: CottagePhotoItemType[] = []

    item.forEach(element => {
      if (element.type === 'PHOTO') {
        const photoItem: CottagePhotoItemType = {
          url: element.url,
          type: element.type,
          alt: element.alt,
          width: element.width !== null ? element.width : 100,
          height: element.height !== null ? element.height : 100,
        }

        returnSlides.push(photoItem)
      }
    })

    return returnSlides
  }

  const getDesktopPhotoItems = (
    item: CottageMediaItemsType,
  ): CottageMediaItemsType => {
    const returnSlides: CottageMediaItemsType = []

    item.forEach(element => {
      if (element.type === 'PHOTO') {
        returnSlides.push(element)
      }
    })

    return returnSlides.slice(0, 5)
  }

  return { getPhotoItems, getDesktopPhotoItems, getVideoItems }
}
